/**
 * Step 3 (renumbered 2026-05-16, was step 5) — What you're hungry for
 *   captures `current_struggles` (multi-select chips)
 *
 * Spec: specs/onboarding-rebuild.md → Act 1 step 3
 *
 * Moved from old step 5 to slot 3 so it follows goal naturally — the user
 * just picked a goal, now answers "what's in the way." Chip pool stays the
 * same 8 universal struggle slugs; per-goal reordering surfaces the most-
 * relevant 3 chips at the top of the list (psychological nudge without
 * pre-selecting). All chips remain visible — a `lead_others` pastor who
 * actually wrestles with doubt still sees the doubt chip.
 */

import HungerChipsSynthesis from './HungerChips.synthesis'

export const HUNGER_OPTIONS = [
  { value: 'prayer_life', label: 'Prayer life' },
  { value: 'doubt', label: 'Doubt' },
  { value: 'scripture_comprehension', label: 'Understanding Scripture' },
  { value: 'defending_faith', label: 'Defending my faith' },
  { value: 'sermon_prep', label: 'Sermon prep' },
  { value: 'daily_walk', label: 'Daily walk with God' },
  { value: 'staying_consistent', label: 'Staying consistent' },
  { value: 'other', label: 'Something else' },
]

// Per-goal chip ordering: top 3 most-relevant slugs surface first. Same
// 8 options shown regardless of goal — just shifted. (Mason lock 2026-05-16:
// "Just reorder, no pre-selection — preserve the vulnerability moment.")
const TOP_CHIPS_BY_GOAL = {
  grow_closer: ['prayer_life', 'staying_consistent', 'daily_walk'],
  know_what_believe: ['doubt', 'defending_faith', 'scripture_comprehension'],
  lead_others: ['sermon_prep', 'staying_consistent', 'scripture_comprehension'],
}

/**
 * Return HUNGER_OPTIONS reordered for the given goal slug. Top-3 most-
 * relevant chips bubble to front; remaining chips keep their relative
 * order. Falls back to default order when goal is missing or unknown.
 */
export function getOrderedChipsForGoal(goal) {
  const topSlugs = TOP_CHIPS_BY_GOAL[goal]
  if (!topSlugs) return HUNGER_OPTIONS
  const topChips = topSlugs.map(slug => HUNGER_OPTIONS.find(o => o.value === slug)).filter(Boolean)
  const rest = HUNGER_OPTIONS.filter(o => !topSlugs.includes(o.value))
  return [...topChips, ...rest]
}

export default function HungerChipsStep({ value, onToggle, onContinue, primaryGoal }) {
  const orderedOptions = getOrderedChipsForGoal(primaryGoal)
  return (
    <HungerChipsSynthesis
      value={value || []}
      onToggle={onToggle}
      onContinue={onContinue}
      options={orderedOptions}
    />
  )
}
